import React, { useContext, useMemo, useState } from "react";
import { useAuth } from "react-oidc-context";
import { socket } from "../redux/socket";

const SocketContext = React.createContext();

export const useSocketContext = () => {
    return useContext(SocketContext);
};

export const SocketProvider = ({ children }) => {
    const [isConnected, setIsConnected] = useState((socket.socket != null));
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const { user } = useAuth();
    const { access_token, token_type } = user || { access_token: null, token_type: null };

    const connect = () => {
        if (socket.socket) {
            setIsConnected(_ => true);
            return;
        }

        if (token_type == null || access_token == null)
            return;

        setIsLoading(_ => true);

        const token = `${token_type} ${access_token}`;
        socket.connect(token).then(() => {
            setIsLoading(_ => false);
            setIsConnected(_ => true);
        });
    };

    return (
        <SocketContext.Provider value={{
            connect,
            isConnected,
            isError,
            isLoading
        }}>
            {children}
        </SocketContext.Provider>
    );
};